import PropTypes from 'prop-types'

import * as R from 'ramda'

import Editor from 'coact/editors/Editor'
import toPath from 'coact/utils/toPath'

import { invoiceRowLabel } from './invoiceRowState.js'

const { object, func } = PropTypes

function InvoiceAction(props) {
  const { invoice, invalidInvoice } = props

  // Every state this column can be in is decided in invoiceRowState, which is
  // covered by its own spec -- there is no React test harness here, so nothing
  // decidable should be left in the JSX.
  const label = invoiceRowLabel(invoice)
  if (label) return label

  return (
    <button
      type="button"
      onClick={() =>
        window.confirm('確認作廢？') ? invalidInvoice(invoice._id) : null
      }
    >
      作廢發票
    </button>
  )
}
InvoiceAction.propTypes = {
  invoice: object.isRequired,
  invalidInvoice: func.isRequired,
}

// Shown on every page that can issue an invoice -- the cashier, the sales order
// and the receivable statement. It used to be copied into all three, which is
// how one null crashed all three.
function InvoiceTable(props) {
  const { ui, invalidInvoice } = props

  return (
    <Editor>
      {editor => {
        const invoices = R.pathOr([], ['value', 'invoices'], editor)

        return (
          <div>
            <table>
              <thead>
                <tr>
                  {ui.fields.map(({ label, width }) => (
                    <th key={label} style={{ width }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {invoices.map(invoice => (
                  <tr key={invoice._id}>
                    {ui.fields.map(({ path }) => (
                      <td key={path}>{R.path(toPath(path), invoice)}</td>
                    ))}
                    <td>
                      <InvoiceAction
                        invoice={invoice}
                        invalidInvoice={invalidInvoice}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }}
    </Editor>
  )
}
InvoiceTable.propTypes = {
  ui: object.isRequired,
  invalidInvoice: func.isRequired,
}

export default InvoiceTable
